import {
  RecommendedProduct,
  RecommendedProductsParams,
  RecommendedProductsResponse,
  useRecommendedProductsBySource,
} from './useRecommendedProductsShared'

const PURCHASES_HOOK_CONFIG = {
  source: 'purchases' as const,
  fetchEventName: 'shop_purchase_recommendations_fetched' as const,
  section: 'from_your_past_purchases' as const,
  fetchErrorNotification: 'Failed to fetch recommendations from purchases',
  fetchErrorLogPrefix: 'Error fetching purchase recommendations',
}

export type { RecommendedProduct, RecommendedProductsParams, RecommendedProductsResponse }

export const useRecommendedProductsFromPurchases = (params: RecommendedProductsParams) =>
  useRecommendedProductsBySource(params, PURCHASES_HOOK_CONFIG)
